import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';
import notFound from '../../../images/notFound.jpg';

const NotFound = () => {
    return (
        <div className='notFound-container d-flex flex-column align-items-center justify-content-center py-5'>
            <img src={notFound} alt="Whoops... Page not found!" />
            <Link to='/home' className='btn btn-outline-success'>Back to Home</Link>
        </div>
    );
};

export default NotFound;